var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { entityLabel } from '@shapeable/utils';
import { Button } from '../elements/button';
import { EntityBubbleImage } from './entity-bubble-image';
import { EntityTypeHeader } from './entity-type-header';
import { OutlineNumber } from '../elements/outline-number';
import { useEntity } from '../hooks/use-entity';
var cls = classNames('entity-sidebar-header');
export var EntityAsideHeaderDefaultProps = {
  showBubbleImage: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ", ";\n    align-self: stretch;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ", ";\n    align-self: stretch;\n  "])), theme.UNIT(1))
});
var TypeStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SaveButtonStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "em;\n    max-width: 100%;\n    font-style: normal;\n    margin: ", " 0;\n    font-weight: 500;\n    line-height: 120%;\n    letter-spacing: -0.4px;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: ", ";\n  "], ["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "em;\n    max-width: 100%;\n    font-style: normal;\n    margin: ", " 0;\n    font-weight: 500;\n    line-height: 120%;\n    letter-spacing: -0.4px;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: ", ";\n  "])), theme.COLOR('strong'), theme.FONT('heading'), 30 / 16, theme.UNIT(2), theme.UNIT(2))
});
var BubbleImageStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-width: 100%;\n  "], ["\n    max-width: 100%;\n  "])))
});
var NumberStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-weight: 600;\n  "], ["\n    font-weight: 600;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Type: styled(EntityTypeHeader)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TypeStyles),
  Name: styled.h1(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Number: styled(OutlineNumber)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), NumberStyles),
  SaveButton: styled(Button)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SaveButtonStyles),
  BubbleImage: styled(EntityBubbleImage)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), BubbleImageStyles)
};
export var EntityAsideHeader = function (props) {
  var className = props.className,
    children = props.children,
    showBubbleImage = props.showBubbleImage;
  var entity = useEntity(props.entity);
  var label = entityLabel(entity);
  if (label === 'Trend') {
    label = 'Value Chain';
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Type, {
    entity: entity
  }, label), React.createElement(My.Name, null, entity.outlineNumber && React.createElement(My.Number, {
    color: entity.color,
    size: 'default'
  }, entity.outlineNumber), entity.name), showBubbleImage && React.createElement(My.BubbleImage, {
    entity: entity,
    size: 200
  }), children);
};
EntityAsideHeader.defaultProps = EntityAsideHeaderDefaultProps;
EntityAsideHeader.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;